export default __webpack_public_path__ + "static/media/quiz-q20.0e19f8cd.png";